import React from 'react'

const ratio = 123 / 51
export default function BluePinkLightTiles({ className = undefined, height = 51 }) {
  return (
    <svg
      id="efPt5SqswuV1"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 123 51"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      width={height * ratio}
      height={height}
    >
      <g transform="translate(42.470001 0)">
        <polygon
          id="efPt5SqswuV3"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(-.127478 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV5"
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV6"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV8"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV9"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV10"
            points="36.6,10.5 36.6,7.5 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 8.148)">
        <polygon
          id="efPt5SqswuV12"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV14"
            points="2.3,10.8 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV15"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV17"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV18"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV19"
            points="19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 8.148)">
        <polygon
          id="efPt5SqswuV21"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV23"
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV24"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV26"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV27"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV28"
            points="22.7,2.4 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,8.3 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(84.938004 16.296)">
        <polygon
          id="efPt5SqswuV30"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV32"
            points="2.4,10.9 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV33"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV35"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV36"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV37"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            transform="translate(-.127479 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.420002 16.296)">
        <polygon
          id="efPt5SqswuV39"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127478 0)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV41"
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV42"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV44"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(-.117366 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV45"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV46"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19.7,17.5 19,17.3 18.4,17.5 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(0 16.296)">
        <polygon
          id="efPt5SqswuV48"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV50"
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV51"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV53"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(.127479 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV54"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV55"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 24.444)">
        <polygon
          id="efPt5SqswuV57"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.127479)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV59"
            points="2.3,10.8 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV60"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV62"
            points="1.5,7.6 19,14.1 36.6,7.6"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV63"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV64"
            points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 24.444)">
        <polygon
          id="efPt5SqswuV66"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.010113 0)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV68"
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            transform="translate(.117367 0)"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV69"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="efPt5SqswuV71"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="efPt5SqswuV72"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV73"
            points="1.5,7.6 19,1 36.6,7.6 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.470001 32.592999)">
        <polygon
          id="efPt5SqswuV75"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="efPt5SqswuV77"
            points="1.5,11.2 1.5,11.2 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line
            id="efPt5SqswuV78"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <line
            id="efPt5SqswuV80"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polyline
            id="efPt5SqswuV81"
            points="1.5,7.5 19,14.1 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="efPt5SqswuV82"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <style>{`#efPt5SqswuV3 {animation: efPt5SqswuV3_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV3_f_p { 0% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #efPt5SqswuV5 {animation: efPt5SqswuV5_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV5_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV6 {animation: efPt5SqswuV6_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV6_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV8 {animation: efPt5SqswuV8_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV8_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV9 {animation: efPt5SqswuV9_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV9_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV10 {animation: efPt5SqswuV10_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV10_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV12 {animation: efPt5SqswuV12_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV12_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #efPt5SqswuV14 {animation: efPt5SqswuV14_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV14_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV15 {animation: efPt5SqswuV15_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV15_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV17 {animation: efPt5SqswuV17_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV17_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV18 {animation: efPt5SqswuV18_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV18_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV19 {animation: efPt5SqswuV19_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV19_s_p { 0% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV21 {animation: efPt5SqswuV21_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV21_f_p { 0% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #efPt5SqswuV23 {animation: efPt5SqswuV23_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV23_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV24 {animation: efPt5SqswuV24_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV24_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV26 {animation: efPt5SqswuV26_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV26_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV27 {animation: efPt5SqswuV27_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV27_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV28 {animation: efPt5SqswuV28_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV28_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV30 {animation: efPt5SqswuV30_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV30_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #efPt5SqswuV32 {animation: efPt5SqswuV32_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV32_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV33 {animation: efPt5SqswuV33_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV33_s_p { 0% {stroke: #cceffc} 29.166667% {stroke: #cceffc} 33.333333% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV35 {animation: efPt5SqswuV35_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV35_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV36 {animation: efPt5SqswuV36_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV36_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV37 {animation: efPt5SqswuV37_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV37_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 29.166667% {stroke: #82d4f2} 33.333333% {stroke: #d82071} 37.5% {stroke: #d82071} 41.666667% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV39 {animation: efPt5SqswuV39_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV39_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 83.333333% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #efPt5SqswuV41 {animation: efPt5SqswuV41_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV41_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV42 {animation: efPt5SqswuV42_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV42_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV44 {animation: efPt5SqswuV44_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV44_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV45 {animation: efPt5SqswuV45_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV45_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV46 {animation: efPt5SqswuV46_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV46_s_p { 0% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV48 {animation: efPt5SqswuV48_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV48_f_p { 0% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #efPt5SqswuV50 {animation: efPt5SqswuV50_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV50_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV51 {animation: efPt5SqswuV51_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV51_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 79.166667% {stroke: #f9c1da} 83.333333% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV53 {animation: efPt5SqswuV53_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV53_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV54 {animation: efPt5SqswuV54_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV54_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV55 {animation: efPt5SqswuV55_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV55_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 79.166667% {stroke: #f26aa6} 83.333333% {stroke: #00abe8} 87.5% {stroke: #00abe8} 91.666667% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #efPt5SqswuV57 {animation: efPt5SqswuV57_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV57_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #efPt5SqswuV59 {animation: efPt5SqswuV59_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV59_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV60 {animation: efPt5SqswuV60_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV60_s_p { 0% {stroke: #cceffc} 37.5% {stroke: #cceffc} 41.666667% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV62 {animation: efPt5SqswuV62_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV62_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV63 {animation: efPt5SqswuV63_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV63_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV64 {animation: efPt5SqswuV64_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV64_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 37.5% {stroke: #82d4f2} 41.666667% {stroke: #d82071} 45.833333% {stroke: #d82071} 50% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV66 {animation: efPt5SqswuV66_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV66_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 83.333333% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #efPt5SqswuV68 {animation: efPt5SqswuV68_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV68_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 83.333333% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV69 {animation: efPt5SqswuV69_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV69_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 83.333333% {stroke: #f9c1da} 87.5% {stroke: #f9c1da} 91.666667% {stroke: #cceffc} 100% {stroke: #cceffc}} #efPt5SqswuV71 {animation: efPt5SqswuV71_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV71_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV72 {animation: efPt5SqswuV72_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV72_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV73 {animation: efPt5SqswuV73_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV73_s_p { 0% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 83.333333% {stroke: #f26aa6} 87.5% {stroke: #f26aa6} 91.666667% {stroke: #00abe8} 95.833333% {stroke: #00abe8} 100% {stroke: #82d4f2}} #efPt5SqswuV75 {animation: efPt5SqswuV75_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV75_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #efPt5SqswuV77 {animation: efPt5SqswuV77_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV77_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV78 {animation: efPt5SqswuV78_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV78_s_p { 0% {stroke: #cceffc} 45.833333% {stroke: #cceffc} 50% {stroke: #f9c1da} 95.833333% {stroke: #f9c1da} 100% {stroke: #cceffc}} #efPt5SqswuV80 {animation: efPt5SqswuV80_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV80_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV81 {animation: efPt5SqswuV81_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV81_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}} #efPt5SqswuV82 {animation: efPt5SqswuV82_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes efPt5SqswuV82_s_p { 0% {stroke: #00abe8} 4.166667% {stroke: #00abe8} 8.333333% {stroke: #82d4f2} 45.833333% {stroke: #82d4f2} 50% {stroke: #d82071} 54.166667% {stroke: #d82071} 58.333333% {stroke: #f26aa6} 95.833333% {stroke: #f26aa6} 100% {stroke: #00abe8}}`}</style>
    </svg>
  )
}
